'use client';
import Styles from './progressive-review.module.scss';
import Image from 'next/image';
import { usePaymentReview, useProgressiveDetails } from '~/store/wmap-store';
import { formatCurrency } from '~/utils/utils';

const ProgressiveReview: React.FC = () => {
  const progressiveDetails = useProgressiveDetails();

  const paymentReview = usePaymentReview();
  if (!paymentReview.review) {
    return <></>;
  }
  return (
    <section className={Styles.progressiveReview}>
      <Image
        src="makeapayment/icons/payment-connector/progressive-review.svg"
        alt="Progressive Review"
        height={48}
        width={180}
        tabIndex={0}
      />
      <div className={Styles.leaseInfo}>
        <span tabIndex={0}>
          <b>
            {' '}
            {`${progressiveDetails?.LeaseDetails?.FirstName} ${progressiveDetails?.LeaseDetails?.LastName}`}
          </b>
        </span>
        <span tabIndex={0}>
          {' '}
          Lease ID: {progressiveDetails?.LeaseDetails?.ApplicationId}
        </span>
        <span tabIndex={0}>
          Approval Amount: {formatCurrency(progressiveDetails?.ApprovalAmount)}
        </span>
      </div>
    </section>
  );
};

export default ProgressiveReview;
